const ImpressumPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Impressum</h1>
      <div className="prose max-w-none">
        <h2 className="text-xl font-semibold mt-6 mb-4">Angaben gemäß § 5 TMG</h2>
        <p className="text-gray-600 mb-4">
          Jonas Vith<br />
          Schmellerstraße 30<br />
          80337 München<br />
          Deutschland
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-4">Kontakt</h2>
        <p className="text-gray-600 mb-4">
          E-Mail: info@mapprints.de oder info.mapprints@gmail.com<br />
          {/* Telefon: +49 15563 246424 */}
        </p>

        {/* <h2 className="text-xl font-semibold mt-6 mb-4">Kleingewerbeanmeldung</h2>
        <p className="text-gray-600 mb-4">
          Gewerbeaufsicht: Stadt München<br />
          [Gewerbeanmeldungsnummer - sobald verfügbar]
        </p> */}

        <h2 className="text-xl font-semibold mt-6 mb-4">Streitschlichtung</h2>
        <p className="text-gray-600 mb-4">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          https://ec.europa.eu/consumers/odr/<br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
        <p className="text-gray-600 mb-4">
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </div>
  );
};

const ImpressumPageEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Legal Notice</h1>
      <div className="prose max-w-none">
        <h2 className="text-xl font-semibold mt-6 mb-4">Information according to § 5 TMG</h2>
        <p className="text-gray-600 mb-4">
          Jonas Vith<br />
          Schmellerstraße 30<br />
          80337 Munich<br />
          Germany
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-4">Contact</h2>
        <p className="text-gray-600 mb-4">
          Email: info@mapprints.de or info.mapprints@gmail.com<br />
          {/* Phone: +49 15563 246424 */}
        </p>

        {/* <h2 className="text-xl font-semibold mt-6 mb-4">Small Business Registration</h2>
        <p className="text-gray-600 mb-4">
          Trade Supervision: City of Munich<br />
          [Business registration number - pending]
        </p> */}

        <h2 className="text-xl font-semibold mt-6 mb-4">Dispute Resolution</h2>
        <p className="text-gray-600 mb-4">
          The European Commission provides a platform for online dispute resolution (ODR):
          https://ec.europa.eu/consumers/odr/<br />
          You can find our email address in the legal notice above.
        </p>
        <p className="text-gray-600 mb-4">
          We are neither willing nor obligated to participate in dispute resolution proceedings
          before a consumer arbitration board.
        </p>
      </div>
    </div>
  );
};

export { ImpressumPageDe, ImpressumPageEn };